<template>
  <div class="lp-custom-modal">
    <div class="lp-custom-modal-title"><slot name="title"></slot></div>
    <div class="lp-custom-modal-desc">
      <slot name="desc"></slot>
    </div>
    <div class="lp-custom-modal-btns">
      <span class="lp-custom-modal-btn-cancel"><slot name="cancel"></slot></span>
      <span class="lp-custom-modal-btn-ok"><slot name="ok"></slot></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'lp-modal',
    data () {
      return {}
    }
  }
</script>

<style lang="stylus" type="styl" scoped>

</style>
